<div [ngClass]="{ 'margin-right-tn': showMessage }" class="icon-wrapper">
  <app-icon [icon]="userLevels[level].icon" class="icon"></app-icon>
</div>
<div *ngIf="showMessage" class="color-white">{{ userLevels[level].title }}</div>
